import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePortalAuth } from '@/contexts/PortalAuthContext';
import { Loader2 } from 'lucide-react';

interface PortalProtectedRouteProps {
  children: React.ReactNode;
}

export const PortalProtectedRoute: React.FC<PortalProtectedRouteProps> = ({ children }) => {
  const { user, portalUser, loading, error } = usePortalAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <span className="text-sm text-muted-foreground">Verificando acesso...</span>
        </div>
      </div>
    );
  }

  // Not authenticated - redirect to portal login
  if (!user) {
    return <Navigate to="/portal" state={{ from: location }} replace />;
  }

  // Authenticated but not a portal user
  if (!portalUser) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <div className="text-center max-w-sm">
          <h1 className="text-xl font-semibold text-foreground mb-2">
            Acesso Negado
          </h1>
          <p className="text-muted-foreground mb-4">
            {error || 'Sua conta não tem acesso ao Portal do Cliente.'}
          </p>
          <a 
            href="/portal"
            className="inline-flex items-center justify-center px-4 py-2 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors"
          >
            Voltar ao Login
          </a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
